import { useConditional } from "../core/hooks/useConditional";
import { Modal } from "../core/ui/Modal";
import { closestKey } from "../core/utils/dom";
import { FormModal } from "../data-entry/FormModal";
import { WorkflowState, wf } from "../types";
import { Edge, Graph, Node, layoutNodes } from "./layout";

const FIXED_ENABLED = true;


function WorkflowLayout(props: {
	wf: wf,

	onEditState: (state: WorkflowState) => void,
}) {

	const def = props.wf.data;

	const edges: Edge[] = [];
	const nodes: Node[] = [];
	const nMap = {} as { [k: string]: Node };
	const stateMap = {} as { [k: string]: WorkflowState };

	const w = 1000;
	const h = 2000;

	const nh = 50;
	let x = w / 3;
	let y = 100;
	for(let s of def.states) {
		stateMap[s.id] = s;

		const n = {
			id: s.id,
			x: x,
			y: y, 
			w: 140,
			h: nh,
		} as Node;
		nodes.push(n);
		nMap[s.id] = n;

		y += nh * 2;
	}

	// first node always fixed
	if (nodes.length > 0 && FIXED_ENABLED) {
		nodes[0].fixed = true;
		nodes[nodes.length-1].fixed = true;	
	}

	for(let s of def.states) {
		for(let t of s.transitions) {
			const source = s.id;
			const target = t.toState;
			if (nMap[source] && nMap[target]) {
				edges.push({
					source: s.id,
					target: t.toState,
					routingPoints: [],
				});		
				
				// if the target state is a default transition that fix that target node
				if (t.isDefault && FIXED_ENABLED) {
					nMap[target].fixed = true;
				}
			}
		}
	}


	const graph: Graph = {
		nodes,
		edges,

		width: w,
		height: h,
	}

	layoutNodes(graph);


	const elNodes: any[] = [];
	const elLines = [];
	for(let n of graph.nodes) {
		const cx = n.x + n.w/2;
		const cy = n.y + n.h/2;

		const state = stateMap[n.id];

		const cls = n.fixed ? "is-fixed" : undefined;

		elNodes.push(
			<g className="state" data-key={state.id} key={state.id}>
				<rect x={n.x} y={n.y} width={n.w} height={n.h} className={cls} />,
				<text x={cx} y={cy} className={cls}>{state.title}</text>
			</g>
		);

		nMap[n.id] = n;
	}

	const edgesProcessed = {} as any;

	let i = 0;
	for(let e of graph.edges) {

		// make sure haven't processed this connection before
		if (edgesProcessed[e.source+"-"+e.target] || edgesProcessed[e.target+"-"+e.source]) continue;
		edgesProcessed[e.source+"-"+e.target] = true;

		const nSrc = nMap[e.source];
		const nDest = nMap[e.target];

		// let cp1x, cp1y, cp2x, cp2y;

		// cp1x = nSrc.x + nSrc.w/2;
		// cp2x = nDest.x + nDest.w/2;

		
		// const gap = 16;

		// if (nDest.y >= (nSrc.y + nSrc.h)) {
		// 	cp1y = nSrc.y + nSrc.h + gap;
		// 	cp2y = nDest.y - gap;
		// } else if (nSrc.y >= (nDest.y + nDest.h)) {
		// 	cp1y = nSrc.y;
		// 	cp2y = nDest.y + nDest.h;
		// } else {
		// 	cp1y = nSrc.y + nSrc.h/2;
		// 	cp2y = nDest.y + nDest.h/2;
		// }

		// let cp = {
		// 	x: cp1x,
		// 	y: cp1y,
		// };
		// let cp2 = {
		// 	x: cp2x,
		// 	y: cp2y,
		// };

		// if (nDest.y > nSrc.y) {
		// 	cp2.y -= 100;
		// 	cp.y += 100;
		// }

		// // const d = `M ${nSrc.x + nSrc.w/2} ${nSrc.y + nSrc.h / 2} C ${c1x} ${c1x}, ${c1x} ${c1x}, ${nDest.x + nDest.w / 2} ${nDest.y + nDest.h/2}`;
		// const d = `M ${cp1x} ${cp1y} C ${cp.x} ${cp.y}, ${cp2.x} ${cp2.y}, ${cp2x} ${cp2y}`;
		// // const d = `M ${cp1x} ${cp1y} L ${cp2x} ${cp2y}`;


		let arrowSizeStart = 0;
		const arrowSizeEnd = 15;

		// check if is also direction back
		let markerStart = undefined;
		const stateEnd = stateMap[e.target];
		for(let t of stateEnd.transitions) {
			if (t.toState === e.source) {
				arrowSizeStart = arrowSizeEnd;
				markerStart = "url(#markerArrowStart)";				
				break;
			}
		}

		const d = getCurvePath(nSrc, nDest, arrowSizeStart, arrowSizeEnd);

		elLines.push(
			<path d={d} key={i} className="rel" 
				markerStart={markerStart}
				markerEnd="url(#markerArrowEnd)" 
			/>
		)
		i++;
	}


	return (
		<svg
			style={{width:"100vw", height: "auto"}}
			xmlns="http://www.w3.org/2000/svg"
			width="500"
			height="1000"

			className="wf-designer"

			onClick={(e: any) => {
				const key = closestKey(e.target, ".state");
				if (!key) return;

				const state = stateMap[key];
				props.onEditState(state);
			}}
		>
			<defs>
				<marker id="markerArrowStart" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto" markerUnits="strokeWidth">
					<path d="M9,0 L9,6 L0,3 z" fill="#aaa" />
				</marker>

				<marker id="markerArrowEnd" markerWidth="10" markerHeight="10" refX="2" refY="3" orient="auto">
					<path d="M2,0 L2,6 L10,3 z" style={{fill: "#aaa"}} />
				</marker>
			</defs>

			{elLines}
			{elNodes}

		</svg>
	);

}


export function Designer(props: {
	wf: wf,
}) {


	const editModal = useConditional((state: WorkflowState) => {
		return (
			<FormModal
				obj={state}
				title={`Edit State - ${state.title}`}
				form="workflow-state-edit"
				size="width-75vw"
				onCancel={editModal.close}
				onSave={(value: WorkflowState) => {
					editModal.close();
				}}
			/>
		)
	});


	return (
		<div>

			<WorkflowLayout
				wf={props.wf} 
				onEditState={(state: WorkflowState) => {
					editModal.show(state);
				}}
			/>

			{editModal.render()}

		</div>

	);
}



function getCurvePath(node1: Node, node2: Node, arrowSizeStart = 10, arrowSizeEnd = 10) {
	// Calculate centers
	const c1x = node1.x + node1.w / 2;
	const c1y = node1.y + node1.h / 2;
	const c2x = node2.x + node2.w / 2;
	const c2y = node2.y + node2.h / 2;

	// Direction deltas
	const dx = c2x - c1x;
	const dy = c2y - c1y;

	if (dx === 0 && dy === 0) {
		return ''; // No path if same center
	}

	// Helper to get all positive t values for intersections with rect boundaries
	function getIntersectionTs(rect: any, cx: number, cy: number, dx: number, dy: number) {
		const ts = [];
		const epsilon = 1e-6;

		// Left edge
		if (Math.abs(dx) > epsilon) {
			const t = (rect.x - cx) / dx;
			if (t >= 0) {
				const y = cy + t * dy;
				if (y >= rect.y - epsilon && y <= rect.y + rect.h + epsilon) {
					ts.push(t);
				}
			}
		}

		// Right edge
		if (Math.abs(dx) > epsilon) {
			const t = (rect.x + rect.w - cx) / dx;
			if (t >= 0) {
				const y = cy + t * dy;
				if (y >= rect.y - epsilon && y <= rect.y + rect.h + epsilon) {
					ts.push(t);
				}
			}
		}

		// Top edge
		if (Math.abs(dy) > epsilon) {
			const t = (rect.y - cy) / dy;
			if (t >= 0) {
				const x = cx + t * dx;
				if (x >= rect.x - epsilon && x <= rect.x + rect.w + epsilon) {
					ts.push(t);
				}
			}
		}

		// Bottom edge
		if (Math.abs(dy) > epsilon) {
			const t = (rect.y + rect.h - cy) / dy;
			if (t >= 0) {
				const x = cx + t * dx;
				if (x >= rect.x - epsilon && x <= rect.x + rect.w + epsilon) {
					ts.push(t);
				}
			}
		}

		return ts;
	}

	// Get exit point from node1
	let ts1 = getIntersectionTs(node1, c1x, c1y, dx, dy);
	let minT1 = Math.min(...ts1.filter(t => t > 1e-6));
	let sx = c1x + minT1 * dx;
	let sy = c1y + minT1 * dy;

	// Get entry point to node2
	let ts2 = getIntersectionTs(node2, c1x, c1y, dx, dy);
	let minT2 = Math.min(...ts2.filter(t => t > 1e-6));
	let ex = c1x + minT2 * dx;
	let ey = c1y + minT2 * dy;

	// Fallback to centers if no intersection
	if (!isFinite(minT1)) {
		sx = c1x;
		sy = c1y;
	}
	if (!isFinite(minT2)) {
		ex = c2x;
		ey = c2y;
	}

	// Helper to get outward normal at attachment point
	function getOutwardNormal(rect: any, px: number, py: number) {
		const epsilon = 1e-6;
		let nx = 0;
		let ny = 0;

		if (Math.abs(px - rect.x) < epsilon) nx = -1; // left
		else if (Math.abs(px - (rect.x + rect.w)) < epsilon) nx = 1; // right
		if (Math.abs(py - rect.y) < epsilon) ny = -1; // top
		else if (Math.abs(py - (rect.y + rect.h)) < epsilon) ny = 1; // bottom

		const len = Math.hypot(nx, ny);
		if (len > 0) {
			nx /= len;
			ny /= len;
		}

		return { nx, ny };
	}

	// Get normals
	const normal1 = getOutwardNormal(node1, sx, sy);
	const normal2 = getOutwardNormal(node2, ex, ey);

	// Offset attachment points outward by arrowSize
	sx += normal1.nx * arrowSizeStart;
	sy += normal1.ny * arrowSizeStart;
	ex += normal2.nx * arrowSizeEnd;
	ey += normal2.ny * arrowSizeEnd;

	// Calculate control offset distance
	const pathDist = Math.hypot(ex - sx, ey - sy);
	const offset = pathDist / 3; // Adjust for curve tightness

	// Control points
	const cx1 = sx + normal1.nx * offset;
	const cy1 = sy + normal1.ny * offset;
	const cx2 = ex + normal2.nx * offset;
	const cy2 = ey + normal2.ny * offset;

	// Generate path
	const d = `M${sx} ${sy} C ${cx1} ${cy1} ${cx2} ${cy2} ${ex} ${ey}`;

	return d;
}